import React from "react";

/**
 * PicImg — drop-in replacement for <img> that emits a <picture> with a WebP
 * source when a sibling .webp file exists in /public. Falls back to the
 * original src for browsers that don't support WebP (~<4% globally in 2026).
 *
 * Usage:
 *   <PicImg src="/hero.png" alt="..." className="..." loading="lazy" />
 *
 * Extra prop `webp={false}` disables the source (useful for SVGs).
 */
export default function PicImg({ src, alt = "", webp = true, ...rest }) {
  if (!src || !webp || /\.(svg|gif|webp|avif)$/i.test(src)) {
    return <img src={src} alt={alt} {...rest} />;
  }
  const webpSrc = src.replace(/\.(png|jpg|jpeg)$/i, ".webp");
  return (
    <picture>
      <source srcSet={webpSrc} type="image/webp" />
      <img src={src} alt={alt} {...rest} />
    </picture>
  );
}
